(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './ModalProvider', './ModalConsumer', './ModalRoot'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./ModalProvider'), require('./ModalConsumer'), require('./ModalRoot'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ModalProvider, global.ModalConsumer, global.ModalRoot);
    global.index = mod.exports;
  }
})(this, function (exports, _ModalProvider, _ModalConsumer, _ModalRoot) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ModalRoot = exports.ModalConsumer = exports.ModalProvider = undefined;

  var _ModalProvider2 = _interopRequireDefault(_ModalProvider);

  var _ModalConsumer2 = _interopRequireDefault(_ModalConsumer);

  var _ModalRoot2 = _interopRequireDefault(_ModalRoot);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.ModalProvider = _ModalProvider2.default;
  exports.ModalConsumer = _ModalConsumer2.default;
  exports.ModalRoot = _ModalRoot2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/ModalManager/index.js
// module id = 861
// module chunks = 1